/**** mgt.Department */

import { translatedRoutesParams } from "consts/vehicles";

const config = {
  schema: 'mgt',
  table: 'Department',
  title: 'Территориальные отделы',
  elemsOnPage: 100,
  connections: {
    depots: {
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
    }
  },
  fields: [
    {
      name: 'td_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true
    },
    {
      name: 'td_name',
      title: 'Наименование',
      type: 'text',
      hide: true
    },
    {
      name: 'td_adress',
      title: 'Адрес',
      type: 'text',
      required: true,
    },
    {
      name: 'td_phone',
      title: 'Номер телефона',
      type: 'text',
      required: false
    },
    {
      name: 'depot_id',
      title: 'Филиал',
      type: 'number',
      required: false,
      connection: 'depots',
      link: 'park'
    },
    {
      name: 'td_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      name: 'td_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      title: 'Координаты',
      type: 'map',
      disableFilter: true,
      composite: {
        type: 'point_coords',
        lat: 'td_lat',
        lon: 'td_lon',
      },
    },
    {
      name: 'td_color',
      title: 'Цвет на карте',
      type: 'color',
      disableFilter: true,
    }
  ],
  defaultSort: {
    field: 'td_id',
    direction: 'desc',
  },
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return `${elem['td_name']}`;
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    const dp =
    connections &&
    connections['depots'] &&
      connections['depots'].find((d: any) => d['depot_id'] === elem['depot_id']);
    return `Адрес: ${elem['td_adress'] || '-'}; Телефон: ${elem['td_phone'] || '-'}; Филиал: ${dp && dp['depot_name'] || '-'}`;
  },
};

export default config;